import { getAttendeeData } from '../selectors/attendeeSelectors';
import { removeSessionFromAttendeeMutator } from '../mutators/attendeeMutators';
import { removeAttendeeFromMruCache } from '../mutators/attendeeMruCacheMutators';

export function removeSessionForAttendees(sessionId: string, attendeeKeys: string[]): void {
    attendeeKeys.forEach(key => {
        const data = getAttendeeData(key);

        if (data?.sessions.some(session => session == sessionId)) {
            removeSessionFromAttendeeMutator(key, sessionId);

            if (data.sessions.length == 0) {
                removeAttendeeFromMruCache(key);
            }
        }
    });
}
